import classNames from 'classnames';

import Image from 'molecules/Image';
import RichText from 'molecules/RichText';
import ThreeColumnGrid from 'molecules/ThreeColumnGrid';

import styles from 'components/ImageCards/imageCards.module.scss';

import type { ImageCardsProps } from 'components/ImageCards/config';
import type { FC } from 'react';

const ImageCards: FC<ImageCardsProps> = ({ cards, enableNegativeMargin }) => {
  const className = classNames(styles.cardList, {
    [styles['cardList--negative']]: enableNegativeMargin,
  });

  return (
    <div className={className}>
      <ThreeColumnGrid>
        {cards?.map(item => (
          <div className={styles.card} key={`cardGrid-${item?.title}`}>
            <Image
              width={711}
              height={537}
              className={styles.imgWrapper}
              url={item.media?.url}
              alt={item?.media?.alt || ''}
            />
            {item?.title && <h3>{item.title}</h3>}
            {item?.body && <RichText content={item.body} />}
          </div>
        ))}
      </ThreeColumnGrid>
    </div>
  );
};

export default ImageCards;
